import { useInstallerContext } from '../context/InstallerContext';
import { getIsPremiumApp } from '../selectors/appForInstallation';
import { INSTALLER_ERRORS } from '../errors';
import { useModalsAndWindow } from '../context/ModalsAndWindowContext';
import { useHandleError } from '../components/ErrorBoundary/ErrorHandlerProvider';
import { useRenderControl } from '../context/InstallerRenderControlContext';
import { getExperiments } from '../services/experiments';
export const useHandleInstallationValidations = () => {
  const {
    prerequisitesState,
    setInstallerUiReady
  } = useRenderControl();
  const {
    modals: {
      upgradeToPremium,
      devModalSiteSelector,
      connectDomain,
      siteSelector,
      incompatibleApp
    }
  } = useModalsAndWindow();
  const {
    handleError
  } = useHandleError();
  const {
    appId,
    version,
    tenantId,
    setTenantId,
    preInstallationData: {
      appForInstallation,
      isSiteConnectedToDomain,
      isPremiumSite,
      isAppCompatible
    }
  } = useInstallerContext();
  const isPremiumApp = getIsPremiumApp(appForInstallation);
  const shouldShowPremiumModal = isPremiumApp && !isPremiumSite;
  const shouldShowDomainModal = isPremiumApp && !isSiteConnectedToDomain;
  const shouldShowIncompatibleAppModal = version !== 'dev' && !isAppCompatible;
  const fulfillValidationByModal = async modal => {
    setInstallerUiReady();
    return modal.open();
  };
  return async () => {
    if (!appId) {
      await handleError(INSTALLER_ERRORS.MISSING_APP_ID);
      return;
    }
    if (prerequisitesState.error) {
      await handleError(prerequisitesState.error);
      return;
    }
    if (!tenantId) {
      var _response$selectedSit;
      const isNewDevVersionsExperimentEnabled = getExperiments().enabled('specs.dcc.test-my-apps-new-experience');
      const response = await fulfillValidationByModal(version === 'dev' && isNewDevVersionsExperimentEnabled ? devModalSiteSelector : siteSelector);
      setTenantId(((_response$selectedSit = response.selectedSite) == null ? void 0 : _response$selectedSit.id) || '');
    }
    if (shouldShowIncompatibleAppModal && getExperiments().enabled('specs.dcc.checkV3StoresAppCompatibility')) {
      await fulfillValidationByModal(incompatibleApp);
    }
    if (shouldShowPremiumModal) {
      await fulfillValidationByModal(upgradeToPremium);
    }
    if (shouldShowDomainModal) {
      await fulfillValidationByModal(connectDomain);
    }
  };
};
//# sourceMappingURL=useHandleInstallationValidations.js.map